module.exports = __webpack_public_path__ + "imgs/leafwell1.a73c921e6f89593d372f63b7b57132e0.svg";